export enum AvailableLanguageMutations {
  CZECH = 'cs',
  ENGLISH = 'en',
}
